<script>
    import { TOKEN_SESSION, USER , TOAST_MESSAGE} from "../stores";
    import { createEventDispatcher } from "svelte";
    import { Datatable, PaginationRowCount, PaginationButtons } from "svelte-simple-datatables";
    import { onMount } from "svelte";
    import * as Fx from "../globals/Fx";
    import * as Valx from "../globals/Valx";
    import GLOBAL from "../globals/GLOBALS";
    import Menuflotante from "./Menuflotante.svelte";
    import DropList from './DropList.svelte'
    
    import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';

    const dispatch = createEventDispatcher();

    console.log($USER)

    let JSONdata
    let sus_id_contrato = "11000707"
    let rowSelected = null
    let modoEdicion = false
    let modoAdicion = false
    let link
    let rows

    const opacity = tweened(0, {
		duration: 2000,
		easing: cubicOut
	});
    let formData = {
        sus_id_contrato : null,
        sus_nic : null,
        sus_nombre : null,
        sus_nit : null,
        sus_id_comercializador : null,
        sus_id_estrato : null,
        sus_id_tarifa : null,
        sus_id_estado : null,
        sus_email : null,
        sus_direccion : null,
        sus_usu_update : $USER.usu_id
    }
    let formDataUndo; 
    let c1 = 'color: #ffc107'
    let c2 = 'color: cyan'
    let action 
    let i = 0

    $: formData && console.log('%c'+JSON.stringify(formData), c1);
    $: formDataUndo && console.log('%c'+formDataUndo, c1);
    $: if (action === "Undo" && formData) {
        console.log('%c'+JSON.stringify(formData), c2);
         action = null
         formData = JSON.parse(formDataUndo)
    } 

    const clearFormData = () => {
        Object.keys(formData).forEach((key) => {
            formData[key] = key !== "clear" ? null : formData[key]
        })
    }

    let opciones = [
        {   // 0
            name: "Refresh",
            desc: "Acutualizar",
            icon: "refresh-outline",
            backgroundColor: "#3498db",
            color: "#fff",
            show: true,
        },
        {   // 1
            name: "Add",
            desc: "Nuevo Suscriptor",
            icon: "add-outline",
            backgroundColor: "#2ecc71",
            color: "#fff",
            show: true,
        },
        {  //  2
            name: "Edit",
            desc: "Editar Suscriptor",
            icon: "pencil-outline",
            backgroundColor: "#e67e22",
            color: "#fff",
            show: false,
        },
        {  // 3
            name: "Undo",
            desc: "Cancelar Edición",
            icon: "arrow-undo",
            backgroundColor: "#e67e22",
            color: "#fff",
            show: false,
        },
        {  // 4
            name: "Cancel",
            desc: "Cancelar",
            icon: "close",
            backgroundColor: "#e67e22",
            color: "#fff",
            show: false,
        },
        {  // 5
            name: "Save",
            desc: "Guardar Cambios",
            icon: "save",
            backgroundColor: "#e74c3c",
            color: "#fff",
            show: false,
        },
    ];

    onMount(async () => {
        _GETDATA();
    });

    const _GETDATA = async () => {
        const data = { sus_id_contrato: sus_id_contrato };
        const URL = GLOBAL.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/suscriptores/GETDATA/GET`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
            // Handle success
            .then((response) => response.json()) // convert to json
            .then((json) => {
                if (json.result === "success") {
                    JSONdata = json.rows;
                    TOAST_MESSAGE.set(json)
                }else{
                    TOAST_MESSAGE.set(json)
                    if (json.status === 403) TOKEN_SESSION.set(null)
                }
            }) //print data to console
            .catch((err) => console.log("Request Failed", err)); // Catch errors
    };

    const _toggleSelect = (id, row) => {
        rowSelected = rowSelected === id ? null : id;
        opciones[1].show = !rowSelected ? true : false //edit
        opciones[2].show = rowSelected ? true : false //edit
        formData = row
        formDataUndo = JSON.stringify(row)
    };

    const settings = {
        sortable: true,
        rowsPerPage: 1000,
        columnFilter: true,
        labels: {
            search: "Buscar...", // search input placeholer
            filter: "Filtro", // filter inputs placeholder
            noRows: "Registro no encontrado",
            info: "Mostrando {start} a {end} de {rows} registros",
            previous: "Anterior",
            next: "Sguiente",
        },
        blocks: {
            searchInput: false, 
            paginationButtons: false,
            paginationRowCount: false,
        }
    };

    const _click_opcion = async (event) => {
        action = null
        switch (event.detail.opcion) {
            case "Refresh":
                JSONdata = null;
                _GETDATA();
                modoEdicion =  false
                modoAdicion =  false
                opciones[1].show = true //add
                opciones[2].show = false //edit
                opciones[3].show = false //undo
                opciones[5].show = false //save
                opciones[4].show = false // cancel
                rowSelected = null
                opacity.set(0)
            break;
            case "Add" : 
                modoEdicion = false
                modoAdicion = true
                clearFormData()
                opacity.set(1)
                opciones[5].show = true //save
                opciones[4].show = true // cancel
            break;
            case "Edit" :
                modoEdicion = rowSelected ? true : false
                opciones[1].show = false //add
                opciones[2].show = !rowSelected ? true : false //edit
                opciones[3].show = rowSelected ? true : false //undo
                opciones[5].show = rowSelected ? true : false //save
                opciones[4].show = false // cancel
                opacity.set(1)
                break;
            case "Undo" :
                formData = JSON.parse(formDataUndo)
                opciones[3].show = false //undo
                opciones[4].show = true // cancel
            break;
            case "Save":
                var r = confirm("ATENCIÓN!!. ¿¿¿Desea guardar los cambios???");
                if (r == true) {
                    _SAVEDATA(modoAdicion ? "INSERT" : "REPLACE")
                } 
            break;
            case "Cancel":
                opciones[1].show = true //add
                opciones[2].show = false //edit
                opciones[3].show = false //undo
                opciones[5].show = false //save
                opciones[4].show = false //cancel
                rowSelected = null
                opacity.set(0)
                modoEdicion = false
                modoAdicion = false
            break;
        }
    };

    const _handleInput = (value) => {
        console.log("value:",value)
    }

    const _bindSelected = (event) => {
        switch(event.detail.lis_tipo){
            case "COMERCIALIZADOR" :
                formData.sus_id_comercializador = event.detail.choosen.lis_id
                formData.desc_comercializador = event.detail.choosen.lis_descripcion
            break;
            case "ESTRATO" :
                formData.sus_id_estrato = event.detail.choosen.lis_id
                formData.desc_estrato = event.detail.choosen.lis_descripcion
            break;
            case "TARIFA APLICADA" :
                formData.sus_id_tarifa = event.detail.choosen.lis_id
                formData.desc_tarifa = event.detail.choosen.lis_descripcion
            break;
            case "ESTADO USUARIO" :
                formData.sus_id_estado = event.detail.choosen.lis_id
                formData.desc_estado = event.detail.choosen.lis_descripcion
            break;
        }
    }

    const _SAVEDATA = async (ACTION) => {
        formData.sus_usu_update = $USER.usu_id
        const data = formData;
        const URL = GLOBAL.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/suscriptores/SAVEDATA/${ACTION}`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
            // Handle success
            .then((response) => response.json()) // convert to json
            .then((json) => {
                if (json.result === "success") {
                    modoEdicion = false
                    modoAdicion = false
                    opciones[1].show = true //add
                    opciones[2].show = false //edit
                    opciones[3].show = false //undo
                    opciones[4].show = false //cabcel
                    opciones[5].show = false //save
                    rowSelected = null
                    opacity.set(0)
                }
                TOAST_MESSAGE.set(json)
            }) //print data to console
            .catch((err) => {
                console.log("Request Failed", err)
                TOAST_MESSAGE.set({
                    result: "error",
                    message : "Atención!. Hubo un error a tratar de guardar. "+err
                })
            }); // Catch errors
    };

    const _exportExcel = () => {
        // console.log(JSONdata)
        let HTML = `<tabla>
            <thead>
                <th data-key="sus_id_contrato">Contrato</th>
                <th data-key="sus_nic">Nic</th>
                <th data-key="sus_nombre">Nombre</th>
                <th data-key="sus_nit">Nit/Cc</th>
                <th data-key=""></th>
                <th data-key="desc_comercializador">Comercializador</th>
                <th data-key=""></th>
                <th data-key="desc_estrato">Estrato</th>
                <th data-key=""></th>
                <th data-key="desc_tarifa">Tarifa</th>
                <th data-key="sus_email">Email</th>
                <th data-key="sus_direccion">Dirección</th>
                <th data-key="sus_last_update">last_update</th>
                <th data-key="sus_usu_update">usu_update</th>
            </thead>
            `
        JSONdata.forEach(element => {
            HTML += `<tr>`
            Object.keys(element).forEach((key) => {
                HTML += `<td>${element[key]}</td>`
            })
            HTML += `</td>`
        })
        HTML += `</table>`

        console.log(HTML)
        const data = Fx.fnExcelReport(HTML, "Listado de Suscriptores")
        console.log(data)
        link.setAttribute("href", data.data_type + ', ' + encodeURIComponent(Fx.myUTF8(data.tab_text)));
        link.setAttribute("download", "Lista_Suscriptores.xls")
        
    }
</script>

<div class="main-suscriptores" >
    <div class="title">Suscriptores</div>
    <div class="d-flex direction-row justify-content-end py-1">
        <!-- <h4>Revisión de Consumos Cargados</h4> -->
        <!-- <div class="btn btn-danger align-self-end"  on:click={() => _close()}>Cerrar</div> -->
        <div class="d-flex direction-row justify-content-end">
            <a class="circular d-flex justify-content-center align-items-center" style="background-color:green"  id="link" bind:this={link} on:click={() => _exportExcel()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-excel-fill" viewBox="0 0 16 16">
                    <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"/>
                  </svg>
            </a>
        </div>
    </div>
    {#if JSONdata}
        <div class="datatable-container">
            <!-- content here -->
            <Datatable {settings} data={JSONdata} bind:dataRows={rows} id={"suscriptores-table"}>
                <thead>
                    <tr>
                        <th data-key="sus_id_contrato">Contrato</th>
                        <th data-key="sus_nic">Nic</th>
                        <th data-key="sus_nombre">Nombre</th>
                        <th data-key="sus_nit">Nit/Cc</th>
                        <th data-key="desc_comercializador">Comercializador</th>
                        <th data-key="desc_estrato">Estrato</th>
                        <th data-key="desc_tarifa">Tarifa</th>
                        <th data-key="desc_estado">Estado</th>
                        <th data-key="sus_email">Email</th>
                        <th data-key="sus_direccion">Dirección</th>
                        <th data-key="sus_last_update">last_update</th>
                        <th data-key="sus_usu_update">usu_update</th>
                    </tr>
                </thead>
                <tbody>
                    {#if modoAdicion}
                        <tr
                            id={`row-0`}
                            class="active"
                        >
                            <td class="edit" style="opacity : {$opacity}" >
                                <input type="text" bind:value={formData.sus_id_contrato} />
                            </td>
                            <td class="edit" style="opacity : {$opacity}" >
                                <input type="number" bind:value={formData.sus_nic}  pattern="[0-9]+" />
                            </td>
                            <td class="edit" style="opacity : {$opacity}" >
                                <input type="text" bind:value={formData.sus_nombre} />
                            </td>
                            <td class="edit" style="opacity : {$opacity}" >
                                <input type="text" bind:value={formData.sus_nit} />
                            </td>
                            <td class="edit" style="opacity : {$opacity}" >
                                <DropList lis_tipo="COMERCIALIZADOR" selected={0} on:_onChange={_bindSelected}/>
                            </td>
                            <td class="edit" style="opacity : {$opacity}" >
                                <DropList lis_tipo="ESTRATO" selected={0} on:_onChange={_bindSelected}/>
                            </td>
                            <td class="edit" style="opacity : {$opacity}" >
                                <DropList lis_tipo="TARIFA APLICADA" selected={0} on:_onChange={_bindSelected}/>
                            </td>
                            <td class="edit" style="opacity : {$opacity}" >
                                <DropList lis_tipo="ESTADO USUARIO" selected={0} on:_onChange={_bindSelected}/>
                            </td>
                            <td class="edit" style="opacity : {$opacity}" >
                                <input type="text" bind:value={formData.sus_email} />
                            </td>
                            <td class="edit" style="opacity : {$opacity}" >
                                <input type="text" bind:value={formData.sus_direccion} />
                            </td>
                            <td>Fecha Registro</td>
                            <td>Usuario</td>
                        </tr>
                    {/if}
                    {#if rows}
                        {#each $rows as row, idx}
                            <tr
                                id={`row-${row.sus_id_contrato}`}
                                class=" {idx % 2 === 0 ? 'bg-par' : 'bg-impar'} 
                                        {`row-${row.sus_id_contrato}` ===  rowSelected ? 'active' : ''}
                                        "
                                on:click={() => !modoAdicion && !modoEdicion && _toggleSelect(`row-${row.sus_id_contrato}`, row)}
                                data-row={JSON.stringify(row)}
                                
                            >
                                {#if modoEdicion && `row-${row.sus_id_contrato}` ===  rowSelected}
                                    <td class="edit" style="opacity : {$opacity}" >{row.sus_id_contrato}</td>
                                    <td class="edit" style="opacity : {$opacity}" >
                                        <input type="number" bind:value={formData.sus_nic}  pattern="[0-9]+" />
                                    </td>
                                    <td class="edit" style="opacity : {$opacity}" >
                                        <input type="text" bind:value={formData.sus_nombre} />
                                    </td>
                                    <td class="edit" style="opacity : {$opacity}" >
                                        <input type="text" bind:value={formData.sus_nit} />
                                    </td>
                                    <td class="edit" style="opacity : {$opacity}" >
                                        <DropList lis_tipo="COMERCIALIZADOR" selected={formData.sus_id_comercializador} on:_onChange={_bindSelected}/>
                                    </td>
                                    <td class="edit" style="opacity : {$opacity}" >
                                        <DropList lis_tipo="ESTRATO" selected={formData.sus_id_estrato} on:_onChange={_bindSelected}/>
                                    </td>
                                    <td class="edit" style="opacity : {$opacity}" >
                                        <DropList lis_tipo="TARIFA APLICADA" selected={formData.sus_id_tarifa} on:_onChange={_bindSelected}/>
                                    </td>
                                    <td class="edit" style="opacity : {$opacity}" >
                                        <DropList lis_tipo="ESTADO USUARIO" selected={formData.sus_id_estado} on:_onChange={_bindSelected}/>
                                    </td>
                                    <td class="edit" style="opacity : {$opacity}" >
                                        <input type="text" bind:value={formData.sus_email} />
                                    </td>
                                    <td class="edit" style="opacity : {$opacity}" >
                                        <input type="text" bind:value={formData.sus_direccion} />
                                    </td>
                                    <td>{row.sus_last_update}</td>
                                    <td>{row.sus_usu_update}</td>
                                {:else}
                                    <td>{row.sus_id_contrato}</td>
                                    <td>{row.sus_nic}</td>
                                    <td>{row.sus_nombre}</td>
                                    <td>{row.sus_nit}</td>
                                    <td>{row.desc_comercializador}</td>
                                    <td>{row.desc_estrato}</td>
                                    <td>{row.desc_tarifa}</td>
                                    <td>{row.desc_estado}</td>
                                    <td>{row.sus_email}</td>
                                    <td>{row.sus_direccion}</td>
                                    <td>{row.sus_last_update}</td>
                                    <td>{row.sus_usu_update}</td>
                                {/if}
                            </tr>
                        {/each}
                    {/if}
                    <!-- {/if} -->
                </tbody>
            </Datatable>
            <Menuflotante {opciones} on:_click_opcion={_click_opcion} />
        </div>
        {:else}
            <div class="center">
                <div class="spinner-border text-warning" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
                <div class="p-1">Procesando</div>
            </div>
        {/if}
    </div>
    <footer>
        <PaginationButtons id={"suscriptores-table"}/>
        <PaginationRowCount id={"suscriptores-table"}/> 
</footer>

<style>
    .main-suscriptores {
        display: flex;
        flex-direction: column;
        padding-top: 0;
        height: 100%;
        padding-bottom: 52px;
    }

    footer {
        position: fixed;
        display: flex;
        background-color: #fff;
        bottom:0;
        width: 100%;
        padding: 10px;
    }

    th {
        min-width: 10em;
        text-align: left;
    }

    td {
        text-align: left;
        white-space: nowrap;
        padding: 10px 10px;
    }

    
    td > input {
        border: none;
        width: 100%;
        padding: 5px 5px;
        border-radius: 5px;
        min-width: 10em;
    }

    td.edit {
        padding: 4px 10px;
    }
    
    tr {
        cursor: pointer;
        color: #3f51b5b5;
        font-size: 0.8em;
        transition: background-color 500ms;
    }
    
    tr:hover {
        background-color:#14518d33;
        color: #2c3e50;
    }

    
    tr.active {
        background-color: #2c3e50 !important;
        color: #fff !important;
    }


    .datatable-container {
        height: 76vh;
        max-height: 100vh;
        padding-top: 12px;
        /* margin: 20px 0; */
    }

    .bg-par {
        background-color: #fafcff;
    }

    .bg-impar {
        background-color: #f2f6ff;
    }

    .title {
        font-size: 3em;
        font-weight: bold;
        padding-right: 20px;
        text-align: right;
        border-bottom: 6px solid;
        color: #2c3e501f;
        line-height: 1;
        background-color: #fff;
    }

    .center {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    
    .circular {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-color: #2c3e50;
        color : #fff;
        cursor: pointer;
        transition: all 250ms;
        margin-right: 10px;
    }

    .circular:hover {
        transform: scale(1.2);
    }

</style>
